import { render, staticRenderFns } from "./AdditionalFieldsCheck.vue?vue&type=template&id=bd6a4a44&scoped=true&lang=pug&"
import script from "./AdditionalFieldsCheck.vue?vue&type=script&lang=ts&"
export * from "./AdditionalFieldsCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6a4a44",
  null
  
)

export default component.exports